import React from 'react';
import classNames from 'classnames';

import { BENEFITS } from '../benefits';
import Hoehenlinien from './Hoehenlinien';
import css from './AuthKulisse.module.css';

/**
 * FairwayBid – Kulisse für Anmeldung und Registrierung
 *
 * Zwei Dinge auf einmal.
 *
 * Der Grund. Statt eines Fotos ein Höhenlinienfeld, das langsam atmet (siehe
 * Hoehenlinien.js). Es liegt hinter der Seite, nicht hinter dem Formular –
 * das steht auf eigenem, deckendem Grund. Ein bewegter Untergrund unter
 * einem Passwortfeld wäre kein Design, sondern ein Hindernis.
 *
 * Die Fläche daneben. Auf breiten Bildschirmen steht links vom Formular
 * Platz, der bisher leer war. Wer sich gerade registriert, hat noch Zweifel –
 * an dieser Stelle wirkt ein Argument mehr als jedes Bild. Deshalb stehen
 * dort dieselben Punkte, die auch auf der Startseite für seine Seite des
 * Marktplatzes werben: für Golfanlagen die eine Liste, für Händler die
 * andere. Die Quelle ist benefits.js, damit nicht zwei Texte auseinander
 * laufen.
 *
 * Kennen wir die Seite nicht – auf der reinen Anmeldeseite etwa –, bleibt die
 * Fläche leer. Einer Golfanlage die Händlerargumente vorzuhalten wäre
 * schlechter als gar nichts.
 *
 * Unter 1024 Pixeln fällt die Fläche weg. Sie über das Formular zu legen
 * hieße, die Eingabefelder aus dem Bild zu schieben - wer sich anmelden will,
 * will sich anmelden.
 */

const SEITE = { customer: 'club', provider: 'dealer' };

/**
 * Wenn die Seite noch offen ist.
 *
 * Über den Knopf in der Kopfzeile landet man auf /signup ohne Nutzertyp –
 * dort steht zuerst die Auswahl "Golfanlage oder Händler". Bis die getroffen
 * ist, wissen wir nicht, wessen Argumente gelten, und die halbe Seite blieb
 * leer. Also etwas, das für beide stimmt: was die Plattform ist, was sie
 * kostet und wer überhaupt hereinkommt.
 *
 * Jeder Satz steht so auch auf der Startseite – zwei Fassungen derselben
 * Aussage laufen sonst irgendwann auseinander.
 */
const NEUTRAL = {
  eyebrow: 'FairwayBid',
  headline: 'Ausschreiben. Vergleichen. Entscheiden.',
  points: [
    'Für Golfanlagen dauerhaft kostenlos – unverbindlich, ohne Mindestlaufzeit',
    'Bei Händlern und Herstellern prüfen wir Handelsregister und USt-IdNr., bevor wir freischalten',
    'Anfragen aus Deutschland, Österreich, der Schweiz, den Niederlanden und Frankreich',
  ],
};

/**
 * @param {string|null} userType die gewählte Seite, falls bekannt
 * @param {boolean} istAnmeldung Anmeldung statt Registrierung?
 */
const AuthKulisse = ({ userType, istAnmeldung = false, className }) => {
  const schluessel = SEITE[userType] || null;
  const passend = schluessel ? BENEFITS.find(b => b.key === schluessel) : null;

  // Bei der Anmeldung keine Argumente: Wer sich anmeldet, ist überzeugt. Dort
  // ist die leere Fläche mit dem Gelände die bessere Antwort.
  const seite = istAnmeldung ? null : passend || NEUTRAL;

  return (
    <>
      <Hoehenlinien />

      {seite ? (
        <aside className={classNames(css.tafel, className)}>
          <p className={css.eyebrow}>{seite.eyebrow}</p>
          <p className={css.headline}>{seite.headline}</p>
          <ul className={css.punkte}>
            {/* Drei reichen. Fünf sind eine Broschüre, und daneben steht ein Formular. */}
            {seite.points.slice(0, 3).map(p => (
              <li key={p} className={css.punkt}>
                {p}
              </li>
            ))}
          </ul>
        </aside>
      ) : null}
    </>
  );
};

export default AuthKulisse;
